// extracted by mini-css-extract-plugin
export default {"container":"Spinner_container__OqyX9","loader":"Spinner_loader__jNzxL","load4":"Spinner_load4__0GxeI"};